<h2 mat-dialog-title>Edit Model Tree</h2>
<div mat-dialog-content>
    <h5 class="text-color-primary">Data Service: {{data.dataservice.data_service_name}}</h5>
    <button mat-raised-button class="root-branch__button" (click)="addRootBranch()">Create Root Branch</button>
    <hr>
    @if (!isLoading) {
        <models-tree [menu]="viewMenu" [branchMenu]="branchMenu" [edit_mode]="true"></models-tree>
    }@else {
        <div class="h-100 d-flex justify-content-center align-items-center loading">
            <mat-progress-spinner mode="indeterminate" class="bright-spinner"> </mat-progress-spinner>
        </div>
    }
</div>

<mat-menu #branchMenu="matMenu">
  <button mat-menu-item (click)="addNestedBranch()">Add branch</button>
  <button mat-menu-item (click)="updateBranch()">Update branch name</button>
  <button mat-menu-item (click)="showViewsMenu()">Link view to branch</button>
  <button mat-menu-item (click)="deleteBranch()">Delete branch</button>
</mat-menu>

<mat-menu #viewMenu="matMenu">
  <button mat-menu-item (click)="unlinkViewToBranch()">Unlink view from branch</button>
</mat-menu>